import { Pipe, PipeTransform } from '@angular/core';

import { Administrateur } from '../../models/administrateur.model';

@Pipe({
  name: 'checkAdminIsAdded',
  pure: false,
})
export class CheckAdminIsAddedPipe implements PipeTransform {

  /**
   * Check if an admin is in the array list
   * @param value Admin array list
   * @param currentUser Current logged user (check if it's added has an admin)
   * @returns True if current logged user has been added els False
   */
  transform(value: Array<Administrateur>, currentUser: Administrateur): boolean {
    return value?.findIndex(x => x.idNatPs === currentUser.idNatPs
      || (x.typePersonne === currentUser.typePersonne
        && x.idPersonne === currentUser.idPersonne)) > -1 || false;
  }

}
